import { Skeleton } from "@/components/ui/Skeleton";

import { type TDensity } from "./types";

type TDataGridLoadingProps = {
  columnCount: number;
  rowCount?: number;
  density: TDensity;
};

/** Skeleton loading rows (not spinners) matching the table layout. */
export function DataGridLoading({ columnCount, rowCount = 6, density }: TDataGridLoadingProps) {
  const padding = density === "compact" ? "px-4 py-2" : "px-4 py-3.5";
  return (
    <tbody aria-busy="true">
      {Array.from({ length: rowCount }).map((_, rowIndex) => (
        <tr
          key={rowIndex}
          className="border-b border-border"
        >
          {Array.from({ length: columnCount }).map((__, colIndex) => (
            <td
              key={colIndex}
              className={padding}
            >
              <Skeleton className="h-4 w-full max-w-[8rem]" />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
}
